/**
 * 管理者専用ルート
 *
 * - 未認証: ログインページへ（returnTo付き）
 * - 認証済み・非管理者: NotFound を表示（ルートの存在を隠す）
 * - 管理者: 子ルートを表示
 */

import { Navigate, Outlet, useLocation } from 'react-router-dom';
import { useAuth } from '@/hooks/useAuth';
import { useIsAdmin } from '@/hooks/useIsAdmin';
import LoadingTips from '@/components/common/LoadingTips';
import NotFound from '@/pages/NotFound';

export default function AdminRoute() {
  const { isAuthenticated, isLoading } = useAuth();
  const { isAdmin, isChecking } = useIsAdmin();
  const location = useLocation();

  if (isLoading || isChecking) {
    return <LoadingTips className="bg-text-50" />;
  }

  if (!isAuthenticated) {
    const returnTo = encodeURIComponent(location.pathname + location.search);
    return <Navigate to={`/auth?returnTo=${returnTo}`} replace />;
  }

  if (!isAdmin) {
    return <NotFound />;
  }

  return <Outlet />;
}
